module.exports = __webpack_public_path__ + "static/media/prepaid-card-gold-new-2021.6133d0a9.jpg";